export function track () {
  if (!window.ga) return

  let args = Array.prototype.slice.call(arguments)
  let newargs = ['send', 'event'].concat(args)

  ga.apply(ga, newargs)
}


// WEBPACK FOOTER //
// ./src/js/actions/analytic.js